<template>
  <div class="measureContent">
    <asset-grid v-if="view === 'grid'"
      :assets="assets"
      :selectedAssetIndexes="selectedAssetIndexes"
      :hasMoreAssets="hasMoreAssets"
      :assetsLoading="assetsLoading"
      :loadingNewPage="loadingNewPage"
      :metricDateStart="metricDateStart"
      :metricDateEnd="metricDateEnd"
      @selectedAssetIndexesChanged="onSelectedAssetIndexesChanged"
      @next-page="onNextPage"
    ></asset-grid>

    <asset-table v-if="view === 'table'"
      :assets="assets"
      :selectedAssetIndexes="selectedAssetIndexes"
      :hasMoreAssets="hasMoreAssets"
      :assetsLoading="assetsLoading"
      :page="page"
      :totalAssetCount="totalAssetCount"
      :columns="columns"
      :queryMetrics="queryMetrics"
      @selected-asset-indexes-changed="onSelectedAssetIndexesChanged"
      @page-change="value => $emit('page-change', value)"
    ></asset-table>
  </div>
</template>

<script>
import AssetGrid from './AssetGrid'
import AssetTable from './AssetTable'

export default {
  name: 'MeasureContent',

  components: {
    AssetGrid,
    AssetTable
  },

  props: {
    assets: {
      type: Array,
      default: () => []
    },
    selectedAssetIndexes: {
      type: Array,
      default: () => []
    },
    hasMoreAssets: {
      type: Boolean,
      default: false
    },
    assetsLoading: {
      type: Boolean,
      default: false
    },
    loadingNewPage: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: 'grid'
    },
    page:  {
      type: Number,
      default: 1
    },
    totalAssetCount: {
      type: Number,
      default: 0
    },
    columns: {
      type: Array,
      default: () => []
    },
    queryMetrics: {
      type: Object,
      default: () => ({})
    },
    metricDateStart: {
      type: String,
      default: '-10000'
    },
    metricDateEnd: {
      type: String,
      default: '0'
    }
  },

  methods: {
    onSelectedAssetIndexesChanged (value) {
      this.$emit('selectedAssetIndexesChanged', value)
    },
    onNextPage () { this.$emit('next-page') }
  }
}
</script>

<style lang="scss"></style>
